import { render } from "./slideSidebar.vue?vue&type=template&id=1b4527a6&scoped=true&ts=true"
import script from "./slideSidebar.vue?vue&type=script&lang=ts"
export * from "./slideSidebar.vue?vue&type=script&lang=ts"

import "./slideSidebar.vue?vue&type=style&index=0&id=1b4527a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4527a6"]])

export default __exports__